function convertStringToArrayBufferView(str) {
  let bytes = new Uint8Array(str.length);
  for (let iii = 0; iii < str.length; iii++) {
    bytes[iii] = str.charCodeAt(iii);
  }
  return bytes;
}

function convertArrayBufferViewToString(buffer) {
  let str = '';
  for (let iii = 0; iii < buffer.byteLength; iii++) {
    str += String.fromCharCode(buffer[iii]);
  }
  return str;
}

// Call on accounts side when you get params
function importEncryptionKeyFromParam(b64Key) {
  const keyInfoString = atob(decodeURIComponent(b64Key));
  const keyInfo = JSON.parse(keyInfoString);
  return crypto.subtle
    .importKey(
      'jwk',
      keyInfo.keyString,
      {
        name: 'AES-CBC',
        iv: convertStringToArrayBufferView(keyInfo.iv),
      },
      true,
      ['encrypt', 'decrypt']
    )
    .then((keyObject) => {
      return {
        keyObject,
        iv: keyInfo.iv,
      };
    });
}

// Call on accounts side, encrypt user info
function encryptUserData(b64Key, userInfoObj) {
  return importEncryptionKeyFromParam(b64Key).then((result) => {
    const encryptPromise = crypto.subtle.encrypt(
      {
        name: 'AES-CBC',
        iv: convertStringToArrayBufferView(result.iv),
      },
      result.keyObject,
      convertStringToArrayBufferView(JSON.stringify(userInfoObj))
    );
    return encryptPromise
      .then((x) => new Uint8Array(x))
      .then(convertArrayBufferViewToString)
      .then(btoa)
      .then(encodeURIComponent);
  });
}

export { encryptUserData };
